module.exports = __webpack_public_path__ + "static/ss10.9e39d5f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/studysmart/ss/ss10.png
// module id = 1187
// module chunks = 81679748166845